import React from 'react';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const formatterNoDecimal = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});

export function currencyNoDecimal(value) {
  return formatterNoDecimal.format(value);
}

export function currency(value) {
  return formatter.format(value);
}

export default function Currency({ children }) {
  return (
    <span>{formatter.format(children)}</span>
  )
}
